import { KeenSliderInstance } from "keen-slider";
import { ref } from "vue";

const slider = ref<KeenSliderInstance>(null);
const current = ref(0);
const slideCount = ref(0);

export const useTicketFamilySlider = () => {
    return {
        slider,
        current,
        slideCount,
    };
};
